<template>
    <div id="Statistics">

        <Head />
        <div class="hotspot clear">
            <Nav ms="/FriendshipLink" />
            <div v-if="tabChange == 0" class="H-right">
                <!-- <span style="margin-left:1rem;font-size:0.18rem;font-weight:800;background:url('../../assets/back/txt.png') left center no-repeat;">通知公告</span> -->
                <div class="title">友情链接管理</div>
                <div class="H-header">
                    <div class="t-left">
                        <input type="text" placeholder="请输入要查询名称" v-model="name" />
                    </div>
                    <div class="t-right">
                        <div class="btn btnmini" @click="tabClick('add')">新增</div>
                    </div>

                </div>
                <div class="t_main">
                    <el-table border
                        :header-cell-style="{ 'background-color': '#001743', 'color': '#fff', 'height': '0.5rem' }"
                        :stripe="true" :data="tableData1" style="width: 100%;max-height:95%"
                        :row-style="{ 'height': '0.4rem' }">
                        <el-table-column label="序号" header-align="center" align="center" width="80">
                            <template slot-scope="scope">
                                <p>{{ scope.row.index }}</p>
                                <i v-if="scope.row.TopNo > 0" class="zd"></i>
                            </template>
                        </el-table-column>
                        <el-table-column prop="name" label="名称" header-align="center" align="center">
                        </el-table-column>
                        <el-table-column prop="Details" label="图片" header-align="center" align="center">
                            <template slot-scope="scope">
                                <div class="imgurl">

                                    <img :src="scope.row.cover" />
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="banner_id" label="链接" header-align="center" align="center" width="280">
                            <template slot-scope="scope">
                                <a :href="scope.row.url" target="_blank">{{ scope.row.url }}</a>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column prop="banner_id" label="启用状态" header-align="center" align="center" width="120">
                            <template slot-scope="scope">
                                <el-switch v-model="scope.row.status" active-value="1" active-color="#13ce66"
                                    @change="statusChange(scope.row)">
                                </el-switch>
                            </template>
                        </el-table-column> -->
                        <el-table-column label="操作" header-align="center" align="center" :width="wid">
                            <template slot-scope="scope">
                                <el-button size="mini" style="background: #2D65D2;color:#ffffff;"
                                    @click="tabClick('edit', scope.row)">修改</el-button>
                                <el-button size="mini" type="danger" @click="Del(scope.row)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination style="text-align: right;height: 0.45rem;" v-if="tableData1.length > 0"
                        @current-change="CurrentChange1" @size-change="handleSizeChange1" :current-page="Page1"
                        :page-size="PageSize1" :page-sizes="[10, 20, 30]" layout="total,sizes, prev, pager, next, jumper"
                        :total="total1"></el-pagination>
                </div>

            </div>
            <div v-if="tabChange == 1" class="H-right">
                <div class="btn btnmini" style="margin-bottom: 0.2rem;" @click="tabChange = 0">返回</div>
                <div class="f-info">
                    <div class="p-info">
                        <div class="p-input">
                            <span>名称：</span>
                            <input type="text" v-model="infoForm.name" />
                        </div>
                        <div class="p-input">
                            <span>链接：</span>
                            <input type="text" v-model="infoForm.url" />
                        </div>
                        <div class="p-input">
                            <span>排序：</span>
                            <input type="number" v-model="infoForm.Order" />
                            <span>*数字越大，排序越靠前</span>
                        </div>
                        <div class="p-input">
                            <span>图片：</span>
                            <div>
                                <div @click="uploadImg" class="btn btnmini" style="width:1rem;">上传</div>
                                <img v-if="infoForm.cover" :src="infoForm.cover" class="avatar"
                                    style="width:2rem; margin-top: 10px;" />
                            </div>
                            <i></i>
                        </div>
                        <!-- <div class="p-input">
                <span>代码：</span>
                <input type="text" v-model="infoForm.FileCode" />
                <i></i>
              </div>-->
                        <!-- <div>
                            <span>内容：</span>
                            <div class="quill">
                                <wangEditor v-model="infoForm.Details" @change="change" />
                            </div>
                            <i>*</i>
                        </div> -->
                    </div>
                    <div class="f-bottom">
                        <div class="btn" @click="submit">提交</div>
                    </div>
                </div>
            </div>
        </div>
        <el-upload ref="uploads" id="upload1" style="opacity:0;height:0;overflow:hidden;" class="avatar-uploader1"
            :http-request="upload" :auto-upload="false" :on-change="submitUpload" action="upload1" :show-file-list="false">
            <i class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <Foot />
    </div>
</template>

<script>
import Head from "../../components/BackHead";
import Foot from "../../components/Foot";
import Nav from "../../components/BackNav";
export default {
    name: "Announcement",
    data() {
        return {
            index: "",
            token: "",
            tabType: "",
            tabChange: 0,
            name: "",
            page: 1,
            num: 10,
            total1: 0,
            tableData1: [],
            Page1: 1,
            value1: 1,
            PageSize1: 10,
            isPopup: false,
            classForm: "",
            fileList: [],
            options: [],
            infoForm: {},
            type: '',
            banner_id: ''
        }
    },
    created() {
        // sessionStorage.setItem("token",'company-70374788cd5a72fc3fb58c59f1c3fdc3')
        this.token = sessionStorage.getItem("token");
        this.getinfo();
    },
    mounted() {
        if (window.outerWidth < 1540) this.wid = "150";
        else this.wid = "210";
    },
    watch: {
        name: function () {
            clearTimeout(this.time);
            this.page = 1
            this.time = setTimeout(() => {
                this.getinfo();
            }, 1000);
        },
    },
    methods: {
        getNew() {
            this.getinfo()
        },
        getType(e) {
            for (var i = 0; i < this.options.length; i++) {
                if (this.options[i].banner_id == e) {
                    return this.options[i].msg;
                }
            }
        },
        getinfo(a) {
            if (a == 1) {
                this.page = 1;
            }
            var that = this;
            that.$axios
                .post(
                    "cooperate/backfriend?token=" + sessionStorage.getItem("token"),
                    that.$qs.stringify({
                        name: this.name,
                        banner_id: this.banner_id,
                        page: this.page,
                        num: this.num
                    })
                )
                .then((res) => {
                    if (res.data.code == 10000) {
                        that.fileList = [];
                        console.log(res.data.data);
                        this.tableData1 = res.data.data.list;
                        this.tableData1.forEach((val, index) => {
                            val.index = index + 1;
                        });
                        console.log(this.tableData1);
                        this.total1 = res.data.data.total_num;
                    } else {
                        this.$message({
                            message: res.data.msg,
                            type: "warning",
                        });
                    }
                });
        },
        CurrentChange1(val) {
            this.page = val;
            this.getinfo();
        },
        handleSizeChange1(val) {
            this.num = val;
            this.getinfo();
        },
        Del(e) {
            var that = this;
            this.$confirm("确认删除吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    that.$axios
                        .post(
                            "cooperate/delfriend?token=" + sessionStorage.getItem("token"),
                            that.$qs.stringify({ id: e.id })
                        )
                        .then((res) => {
                            console.log(res);
                            if (res.data.code == 10000) {
                                that.$message({
                                    message: "删除成功",
                                    type: "success",
                                });
                                that.getinfo();
                                // this.reload();
                            } else {
                                that.$message.error(res.data.msg);
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },
        statusChange(e) {
            let that = this
            this.$axios
                .post(
                    "banner/status?token=" + sessionStorage.getItem("token"),
                    that.$qs.stringify({ id: e.id })
                )
                .then((res) => {
                    console.log(res);
                    if (res.data.code == 10000) {
                        that.$message({
                            message: "状态切换成功",
                            type: "success",
                        });
                        that.getinfo();
                        // this.reload();
                    } else {
                        that.$message.error(res.data.msg);
                    }
                });
        },
        tabClick(type, form) {
            this.tabChange = 1
            this.type = type
            if (type == 'add') {
                this.infoForm = {}
            } else {
                this.infoForm = JSON.parse(JSON.stringify(form))
            }
        },
        uploadImg() {
            document.querySelector(".avatar-uploader1 input").click();
        },
        upload(file) {
            let that = this;
            console.log(file);
            var formData = new FormData();
            formData.append("file", file.file);
            formData.append("upload_type", "image");
            that.$axios
                .post(
                    "upload/index?token=" + sessionStorage.getItem("token"),
                    formData,
                    {
                        headers: {
                            "Content-type": "multipart/form-data",
                        },
                    }
                )
                .then((res) => {
                    if (res.data.code == 10000) {
                        console.log(res.data.data);
                        this.infoForm.cover = res.data.data;
                        this.$message({
                            message: res.data.msg,
                            type: "success",
                        });
                        this.$forceUpdate()
                    }
                });
            this.$refs.uploads.clearFiles();
        },
        submitUpload() {
            this.$refs.uploads.submit();
        },
        submit() {
            let that = this
            if (this.type == 'add') {
                this.$confirm("确认提交该信息, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }).then(() => {
                    that.$axios
                        .post(
                            "cooperate/addfriend?token=" + sessionStorage.getItem("token"),
                            that.$qs.stringify(this.infoForm)
                        )
                        .then((res) => {
                            if (res.data.code == 10000) {
                                console.log(res.data.data);
                                that.fileList = [];
                                for (var key in that.infoForm) {
                                    that.infoForm[key] = "";
                                }
                                //提交成功后返回
                                this.tabChange = 0;
                                that.$message({
                                    message: res.data.msg,
                                    type: "success",
                                });
                                that.getinfo();
                                // this.Popups(0);
                            } else {
                                this.$message({
                                    message: res.data.msg,
                                    type: "warning",
                                });
                            }
                        });
                });
            } else {
                this.$confirm("确认提交该信息, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }).then(() => {
                    that.$axios
                        .post(
                            "cooperate/editfriend?token=" + sessionStorage.getItem("token"),
                            that.$qs.stringify(this.infoForm)
                        )
                        .then((res) => {
                            if (res.data.code == 10000) {
                                console.log(res.data.data);
                                that.fileList = [];
                                for (var key in that.infoForm) {
                                    that.infoForm[key] = "";
                                }
                                //提交成功后返回
                                this.tabChange = 0;
                                that.$message({
                                    message: res.data.msg,
                                    type: "success",
                                });
                                that.getinfo();
                                // this.Popups(0);
                            } else {
                                this.$message({
                                    message: res.data.msg,
                                    type: "warning",
                                });
                            }
                        });
                });
            }
        }
    },
    components: {
        Head,
        Foot,
        Nav,
    },
}
</script>
<style lang="less" scoped>
.el-dropdown {
    display: none;
}

.btns {
    display: flex;
}

@media screen and (max-width: 1800px) {
    .el-dropdown {
        display: block;
    }

    .btns {
        display: none !important;
    }

    .el-table__row td:last-child {
        .cell {
            padding-left: 0px;

            .el-button {
                font-size: 12px;
            }
        }
    }

    .el-dropdown-menu {
        li {
            padding: 0;

            span {
                display: inline-block;
                padding: 0 20px;
                width: 100%;
                height: 100%;
            }
        }

        li:hover {
            color: #fff !important;
        }

        li:first-of-type:hover {
            background: #2d65d2;
        }

        li:nth-of-type(2):hover {
            background: #f3252f;
        }

        li:last-of-type:hover {
            background: #f76423;
        }
    }
}

.fj {
    width: 50%;

    .anniu {
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin-left: 0.2rem;
    }
}

.clear:after {
    /*伪元素是行内元素 正常浏览器清除浮动方法*/
    content: "";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
}

select {
    font-size: 0.16rem;
    height: 0.5rem;
}

// .editor{
//   width: 100%;
//   height: 3rem;
// }
.btn {
    width: 4.6rem;
    cursor: pointer;
    height: 0.58rem;
    line-height: 0.58rem;
    font-size: 0.17rem;
    text-align: center;
    background: #2d65d2;
    color: #fff;
}

.btnchange {
    background-color: #ffffff;
    border: 1px #aaaaaa solid;
    color: #000000;
}

.btnmini {
    width: 1rem;
    height: 0.4rem;
    line-height: 0.4rem;
    border-radius: 0.05rem;
}

.hotspot {
    width: 100%;
    min-width: 1000px;
    font-size: 0.16rem;
    padding: 0.28rem 2.54rem;
    box-sizing: border-box;

    .H-right {
        position: relative;
        width: 11.5rem;
        padding-left: 0.2rem;
        height: 100%;
        float: right;
        min-height: 8rem;
        border-left: 1px #eeeeee solid;

        .title {
            font-size: 0.4rem;
            margin: 0.2rem 0 0.5rem;
            text-align: center;
        }

        .btnselect {
            display: flex;
        }

        .H-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 0.5rem;

            .t-left {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                height: 0.5rem;
                width: 40%;

                >span,
                select,
                div,
                input {
                    margin-right: 0.2rem;
                }

                input {
                    padding: 0.05rem;
                }
            }

            .t-right {
                float: right;
                margin-bottom: 0.1rem;

            }
        }
    }
}

.Popup {
    width: 100%;
    position: absolute;
    top: 0;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    z-index: 1000;

    .none {
        width: 100%;
        height: 100%;
        position: relative;
    }

    .a_forms {
        position: absolute;
        left: 50%;
        top: 0.5rem;
        transform: translate(-50%, 0);
        width: 10.11rem;
        height: 8rem;
        background: white;
        font-size: 0.16rem;

        .f-top {
            height: 0.5rem;
            width: 100%;
            text-align: center;
            line-height: 0.5rem;
            position: relative;
            border-bottom: 1px #cfcfcf solid;

            div {
                cursor: pointer;
                position: absolute;
                right: 0;
                top: 0;
                height: 0.5rem;
                width: 0.5rem;
                background: url("../../assets/back/x.png") center center no-repeat;
            }
        }
    }
}

.t_main {
    .zd {
        display: inline-block;
        width: 0.3rem;
        height: 0.3rem;
        background-image: url("../../assets/back/zd.png");
        background-repeat: no-repeat;
        position: absolute;
        top: 0;
        left: 0;
        background-size: 100%;
    }
}

.f-info {
    padding: 0 0.54rem;

    .p-info {
        >.p-input {
            align-items: center;

            >div {
                position: relative;
                flex: 1;
                margin: 0 0.2rem;
            }
        }

        >.upimg {
            align-items: center;
            justify-content: space-between;
        }

        >div {
            margin: 0.2rem 0;
            display: flex;

            >.p-time {
                position: relative;
                flex: 1;
                margin: 0 0.2rem;

                >input {
                    width: 100%;
                    padding: 0.05rem;
                    height: 0.4rem;
                    border: 1px #cccccc solid;
                }

                .p-select {
                    width: 100%;
                    top: 0;
                    left: 0;
                    opacity: 0;
                    position: absolute;
                }

                .icon {
                    position: absolute;
                    top: 0;
                    right: 0;
                    height: 0.4rem;
                    width: 0.4rem;
                    background: url("../../assets/back/time.png") center center no-repeat;
                }
            }

            >input,
            select {
                flex: 1;
                padding: 0.05rem;
                margin: 0 0.2rem;
                height: 0.4rem;
                border: 1px #cccccc solid;
            }

            >.quill {
                max-width: 89%;
                flex: 1;
                margin: 0 0.2rem;
            }

            i {
                font-style: normal;
                color: #ff0d0d;
                width: 0.2rem;
            }
        }
    }

    .f-bottom {
        display: flex;
        justify-content: space-around;
        align-items: center;
    }
}

.hMain {
    position: relative;
    border: 1px solid #ababab;
    margin: 0 auto;
    background: #fafdff;

    span {
        display: inline-block;
        width: 0.1rem;
    }

    >p {
        width: 97%;
        font-size: 0.22rem;
        margin: 0 auto;
        padding-bottom: 0.1rem;
        color: #4f4f4f;
        text-indent: 2em;
        margin-bottom: 0.1rem;
    }

    >p:nth-of-type(1) {
        text-align: center;
        font-size: 0.35rem;
        color: #333;
        border-bottom: 1px solid #ccc;
        padding-bottom: 0.3rem;
        font-weight: bold;
        margin: 0.3rem 0;
    }

    >p:nth-of-type(2) {
        height: 0.5rem;
        line-height: 0.5rem;
        background: #f4f9fd;
        text-align: center;
        font-size: 0.18rem;
        color: #666666;
        margin-top: 0.3rem;
        margin-bottom: 0.4rem;
    }

    div {
        width: 96%;
        border: 1px dashed #ddd;
        // background: #f0f6fb;
        margin: 0.6rem 0 0 0.2rem;
        padding: 0.1rem 0;
        font-size: 0.2rem;
        text-indent: 2em;

        p {
            line-height: 1.5;
        }

        p:nth-of-type(1) {
            margin-bottom: 0.1rem;
        }
    }

    .fj {
        p {
            margin: 0.3rem 0 0.2rem !important;
        }

        ul {
            padding-left: 0.6rem;
        }

        li {
            font-size: 0.16rem;
            text-decoration: underline;
            margin-bottom: 0.2rem;

            a.active {
                color: royalblue;
            }
        }
    }
}

.imgurl {

    width: 100%;
    height: 100px;

    img {
        width: 100%;
        height: 100%;
        object-fit: contain
    }
}
</style>